import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { useModal } from './context';
export function ModalBackdrop() {
    const { close } = useModal();
    return (_jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.15 }, className: "fixed top-0 left-0 bg-bg-overlay w-full h-full cursor-default z-60", onClick: close }));
}
